<template>
    <renraku-create-form />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import RenrakuCreateForm from '@/components/renraku/create/Form.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'renraku-create-form': RenrakuCreateForm
    }
})
</script>
